var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryWorldBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9318 136.063C50.9601 136.063 40.9885 136.044 31.0214 136.09C30.043 136.09 29.7687 135.852 29.7778 134.883C29.8235 130.11 29.7412 125.333 29.8144 120.561C29.883 116.039 33.5818 113.008 38.0304 113.658C54.2474 116.021 70.4691 118.366 86.6908 120.73C90.6273 121.306 94.5593 121.927 98.4958 122.522C101.097 122.915 103.607 122.183 106.136 121.827C116.043 120.437 125.933 118.951 135.831 117.498C144.536 116.218 153.242 114.947 161.942 113.658C166.318 113.008 170.039 115.966 170.144 120.41C170.259 125.288 170.149 130.17 170.195 135.048C170.204 136.063 169.738 136.081 168.947 136.081C149.319 136.053 129.696 136.044 110.068 136.035C107.224 136.035 106.908 136.351 106.904 139.189C106.904 142.705 106.872 146.22 106.922 149.736C106.94 150.769 106.739 151.217 105.569 151.194C101.843 151.121 98.1163 151.121 94.3901 151.194C93.2105 151.217 93.0276 150.755 93.0413 149.731C93.0916 146.006 93.0688 142.28 93.0596 138.554C93.0551 136.607 92.4881 136.04 90.5221 136.04C80.6556 136.031 70.7892 136.04 60.9272 136.04C60.9272 136.049 60.9272 136.058 60.9272 136.072L60.9318 136.063Z",
    fill: "url(#paint0_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4322 139.687C68.3568 139.687 77.2769 139.687 86.2015 139.687C88.8625 139.687 89.2923 140.131 89.2968 142.796C89.2968 145.576 89.2785 148.36 89.306 151.139C89.3288 153.635 90.4673 154.81 92.9728 154.833C97.6454 154.869 102.313 154.869 106.986 154.833C109.556 154.815 110.662 153.63 110.68 151.002C110.699 148.378 110.68 145.754 110.68 143.13C110.68 140.012 111 139.683 114.068 139.683C127.135 139.683 140.207 139.683 153.274 139.683C158.051 139.683 162.829 139.628 167.602 139.701C172.92 139.779 176.298 144.433 174.525 149.118C173.432 152.012 170.835 153.658 167.305 153.658C153.713 153.662 140.115 153.681 126.523 153.635C125.078 153.63 124.419 153.841 124.058 155.519C122.508 162.783 116.583 168.108 108.884 168.639C102.62 169.068 96.2875 169.206 90.0192 168.502C83.0011 167.715 77.0894 162.12 75.8275 155.24C75.5669 153.822 75 153.64 73.7793 153.64C60.0265 153.676 46.2784 153.667 32.5256 153.658C28.8634 153.658 26.2116 151.756 25.2743 148.533C24.1267 144.597 26.7374 140.465 30.7882 139.852C31.6158 139.729 32.4616 139.692 33.2937 139.687C42.0081 139.678 50.7178 139.678 59.4322 139.678V139.687Z",
    fill: "url(#paint1_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.844 118.403C108.742 112.163 114.996 106.915 121.886 102.453C130.72 96.7292 140.22 92.5829 150.603 90.608C152.396 90.2697 154.183 89.8171 156.031 90.4343C158.691 91.3211 160.753 93.744 160.758 96.4869C160.767 100.898 159.894 105.241 159.492 109.625C159.409 110.503 158.669 110.352 158.179 110.425C154.348 111.02 150.512 111.564 146.676 112.121C137.71 113.429 128.744 114.727 119.779 116.039C114.493 116.812 109.213 117.612 103.927 118.394C103.68 118.43 103.42 118.398 102.835 118.398L102.844 118.403Z",
    fill: "url(#paint2_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1425 118.508C93.4894 117.977 90.1884 117.502 86.8874 117.022C78.5937 115.811 70.2999 114.604 62.0108 113.388C55.2716 112.4 48.537 111.39 41.7977 110.435C40.7736 110.288 40.4718 109.863 40.3804 108.853C40.0421 105.095 39.4477 101.36 39.2054 97.5977C38.8899 92.6971 42.8173 89.4787 47.6545 90.3016C64.0271 93.0857 77.8621 100.889 90.1975 111.687C92.5521 113.749 94.8519 115.87 97.1425 118.508Z",
    fill: "url(#paint3_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.958 49.4964C145.949 50.8999 145.094 51.5444 143.43 51.6542C137.322 52.0519 133.029 55.0965 130.454 60.6097C129.741 62.1412 129.371 63.7778 129.275 65.4601C129.165 67.4258 128.585 68.3813 127.341 68.3264C125.535 68.2441 125.448 66.859 125.325 65.5058C124.744 59.156 121.452 54.8176 115.54 52.477C114.224 51.9559 112.834 51.6816 111.403 51.6496C109.61 51.6084 108.696 50.941 108.659 49.725C108.618 48.4861 109.482 47.8187 111.298 47.6769C118.293 47.1329 123.418 42.8266 125.009 36.1019C125.224 35.1922 125.311 34.2413 125.37 33.3041C125.453 31.9967 125.928 30.9452 127.368 31.0001C128.767 31.055 129.197 32.0927 129.275 33.4139C129.627 39.4391 132.576 43.7637 137.98 46.4061C139.74 47.2655 141.629 47.6541 143.595 47.7044C144.861 47.7364 145.849 48.2072 145.954 49.4918L145.958 49.4964Z",
    fill: "url(#paint4_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5377 81.6523C69.2804 81.6751 68.6083 80.8568 68.5305 79.1837C68.2974 74.3059 66.1485 70.4658 62.2165 67.6269C59.8162 65.8897 57.073 65.108 54.1377 64.9297C52.6106 64.8383 51.7282 64.0977 51.8517 62.9457C51.998 61.6108 52.8758 61.1857 54.1514 61.1125C62.2531 60.6325 68.1099 54.8038 68.5305 46.8631C68.6174 45.19 69.2804 44.3488 70.5377 44.3991C72.1653 44.4631 72.4168 45.6517 72.4991 46.9271C72.874 52.9844 75.9144 57.2313 81.314 59.8416C83.0743 60.6919 84.9899 61.0622 86.9376 61.1217C88.2498 61.1582 89.1414 61.7251 89.1551 63.0234C89.1688 64.3309 88.2681 64.852 86.9651 64.948C79.5126 65.5057 74.1953 69.9904 72.7277 76.9254C72.522 77.8945 72.5448 78.9048 72.4077 79.8877C72.2613 80.9483 71.6761 81.602 70.5468 81.6477L70.5377 81.6523Z",
    fill: "url(#paint5_linear_25_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.616 95.5772C98.7107 95.5772 94.6552 91.5086 94.7284 86.6582C94.797 81.8398 98.8158 77.8672 103.612 77.8672C108.472 77.8672 112.564 81.9861 112.505 86.8091C112.445 91.6411 108.454 95.5772 103.616 95.5772Z",
    fill: "url(#paint6_linear_25_495)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_495",
    x1: 99.9881,
    y1: 113.568,
    x2: 99.9881,
    y2: 151.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_495",
    x1: 100.002,
    y1: 139.663,
    x2: 100.002,
    y2: 168.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_495",
    x1: 131.796,
    y1: 90.1284,
    x2: 131.796,
    y2: 118.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_495",
    x1: 68.1651,
    y1: 90.1733,
    x2: 68.1651,
    y2: 118.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_495",
    x1: 127.308,
    y1: 30.998,
    x2: 127.308,
    y2: 68.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_495",
    x1: 70.4977,
    y1: 44.397,
    x2: 70.4977,
    y2: 81.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_495",
    x1: 103.616,
    y1: 77.8672,
    x2: 103.616,
    y2: 95.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 138,
    fill: "white",
    transform: "translate(25 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryWorldBuilding);
export default __webpack_public_path__ + "static/media/Story_&_World-Building.1fc417d45e7b6b4de726a1018db49563.svg";
export { ForwardRef as ReactComponent };